import { jsxs as _jsxs } from "@redneckz/uni-jsx/jsx-runtime";
import { JSX } from '@redneckz/uni-jsx';
import { useCallback, useState } from '@redneckz/uni-jsx/lib/hooks';
export const Foldable = JSX(({ className = '', isFoldButtonOnTop = false, unfoldedByDefault = false, renderFoldableSection, renderFoldButton, }) => {
    const [isUnfolded, setIsUnfolded] = useState(unfoldedByDefault);
    const onToggle = useCallback(() => {
        setIsUnfolded((_) => !_);
    }, []);
    const sectionNode = renderFoldableSection({ isUnfolded, onToggle });
    const buttonNode = renderFoldButton ? renderFoldButton({ isUnfolded, onToggle }) : null;
    return isFoldButtonOnTop ? (_jsxs("div", { className: className, role: "group", children: [buttonNode, sectionNode] })) : (_jsxs("div", { className: className, role: "group", children: [sectionNode, buttonNode] }));
});
//# sourceMappingURL=Foldable.js.map